import * as React from 'react';
import * as style from './style.css';
import { ErrorScreen as ErrorScreenComponent } from '../../../LayoutModal/parts/ErrorScreen';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorScreen = function ErrorScreen(_ref) {
  var onReset = _ref.onReset;
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    children: /*#__PURE__*/_jsx(ErrorScreenComponent, {
      onReset: onReset,
      buttonTheme: "fill_secondary"
    })
  });
};